/**
 * Shared time utilities
 */

/**
 * Get the current timestamp in ISO 8601 format
 */
export function nowIso(): string {
  return new Date().toISOString();
}
